import { z } from "zod";
const DimensionsVariableScopeSchema = z.enum([
    "CORNER_RADIUS",
    "WIDTH_HEIGHT",
    "GAP",
    "STROKE_FLOAT",
    "EFFECT_FLOAT",
    "OPACITY",
    "FONT_SIZE",
    "LINE_HEIGHT",
    "LETTER_SPACING",
    "PARAGRAPH_SPACING",
    "PARAGRAPH_INDENT",
    "FONT_WEIGHT",
]);
const StringVariableScopeSchema = z.enum([
    "TEXT_CONTENT",
    "FONT_FAMILY",
    "FONT_STYLE",
]);
export const DimensionsVariableScopeType = DimensionsVariableScopeSchema.enum;
export const StringVariableScopeType = StringVariableScopeSchema.enum;
const VariableScope = z.string();
const ReferencedVariableOrigin = z.object({
    name: z.string(),
    remote: z.boolean(),
});
export const RGB = z.object({
    r: z.number(),
    g: z.number(),
    b: z.number(),
});
export const RGBA = RGB.extend({
    a: z.number(),
});
export const VariableAlias = z.object({
    type: z.literal("VARIABLE_ALIAS"),
    id: z.string(),
    resolvedValue: z
        .boolean()
        .or(z.number())
        .or(z.string())
        .or(RGBA)
        .or(RGB)
        .optional(),
    referenceOrigin: ReferencedVariableOrigin.optional().or(z.null()),
});
export const VariableValue = z
    .boolean()
    .or(z.number())
    .or(z.string())
    .or(RGBA)
    .or(RGB)
    .or(VariableAlias);
export const ResolvedVariableType = z.enum([
    "BOOLEAN",
    "FLOAT",
    "STRING",
    "COLOR",
]);
export const Variable = z.object({
    id: z.string(),
    name: z.string(),
    key: z.string(),
    variableCollectionId: z.string(),
    variableCollectionKey: z.string(),
    resolvedType: ResolvedVariableType,
    valuesByMode: z.record(VariableValue),
    remote: z.boolean(),
    description: z.string(),
    hiddenFromPublishing: z.boolean(),
    scopes: z.array(VariableScope),
    codeSyntax: z.record(z.any()).optional(),
});
export const VariableMode = z.object({
    modeId: z.string(),
    name: z.string(),
    parentModeId: z.string().optional(),
});
export const Collection = z.object({
    id: z.string(),
    name: z.string(),
    key: z.string(),
    modes: z.array(VariableMode),
    defaultModeId: z.string(),
    remote: z.boolean(),
    hiddenFromPublishing: z.boolean(),
    isExtension: z.boolean().optional(),
    parentVariableCollectionId: z.string().optional(),
    parentVariableCollectionKey: z.string().optional(),
    variableOverrides: z
        .record(z.string(), z.record(z.string(), VariableValue))
        .optional(),
});
export const VariablesMapping = z.object({
    variableCollections: z.array(z.string()).min(1),
    variableCollectionKeys: z.array(z.string()),
    variableMode: z.string().min(1),
    supernovaBrand: z.string().min(1),
    supernovaTheme: z.string().min(1).nullable().optional(),
});
export const VariableCollectionsSchema = z.record(z.string(), Collection);
export const VariablesSchema = z.record(z.string(), Variable);
export const FormattedCollections = z.object({
    variableCollections: VariableCollectionsSchema,
    variables: VariablesSchema,
    variablesOrder: z.string().array().optional(),
    mappings: z.array(VariablesMapping).optional(),
});
